module.exports = __webpack_public_path__ + "static/media/bin.705c26c4.svg";